module.exports = __webpack_public_path__ + "static/media/handshake.ef90d864.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/handshake.png
// module id = 768
// module chunks = 0